import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import React from "react";
import type { FaqItem } from "../../content/roleFaqsContent";
import { Reveal, StaggerGroup } from "../../theme/animation";

interface FAQSectionProps {
  faqs: FaqItem[];
  id?: string;
}

const FAQSection: React.FC<FAQSectionProps> = ({ faqs, id = "faqs" }) => {
  return (
    <Box id={id} component="section" sx={{ mb: 6 }}>
      <Reveal variant="fadeUp">
        <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: "bold" }}>
          Frequently Asked Questions
        </Typography>
      </Reveal>
      <StaggerGroup stagger={0.06}>
        {faqs.map((faq, index) => (
          <Reveal key={index} variant="fadeUp" staggerIndex={index}>
            <Accordion elevation={2} sx={{ mb: 2 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            sx={{
              "& .MuiAccordionSummary-content": { margin: "16px 0" },
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
            </Accordion>
          </Reveal>
        ))}
      </StaggerGroup>
    </Box>
  );
};

export default FAQSection;
